import React, {useState} from 'react';
import styled, {css} from 'styled-components';
import {formatCurrency} from "../utils/formatCurrency";
import {Trans} from "../utils/i18n";
import FormControl from "@material-ui/core/FormControl";
import {InputLabel, Select} from "@material-ui/core";
import classNames from "classnames";
import {InertiaLink, usePage} from '@inertiajs/inertia-react';
import {isNaN, isNil} from 'lodash';
import {ProductModal} from './ProductModal';
import {ImagePlaceholder} from './ImagePlaceholder';
import PartMissingModal from "./PartMissingModal";

const Label = styled.label`
    width: 100%;
    height: 100%;
    padding: 20px;
    display: inline-flex;
    flex-direction: column;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px;
    position: relative;
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: .5rem;
    text-align: center;

    ${props => props.error && css`
        border-color: red;
        border-width: 5px;
    `}
`;

const LabelText = styled.p`
    margin: 5px 0;
    font-weight: 700;
    text-align: center;

    ${props => props.checked && css`
        color: ${props => props.theme.primary};
    `}
`;

const LabelDescription = styled.p`
    margin: 5px 0;
    color: ${props => props.theme.gray};
    text-align: center;

    ${props => props.size === 'small' && css`
        font-size: 12px;
    `}
 `;

const Image = styled.img`
    max-width: 100%;
    height: 100px;
    object-fit: contain;
`;

function RadioBigWithAmount(props) {
    const {disabled, field, input, meta: {touched, error}} = props;
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);

    const notZero = !!Number(input.value);
    // Allow to use custom onChange handler (e. g. for ArrayFields)
    const onChange = props.onChange ?? input.onChange;

    const page = usePage();

    return (
        <div style={{height: '100%'}}>
            <Label
                as="div"
                error={touched && error}
            >
                <div className={""}>
                    {field.image ? (
                        <Image src={field.image} alt={field.description}/>
                    ) : (
                        <ImagePlaceholder/>
                    )}
                </div>
                <LabelText checked={notZero} className="text-lg">{field.titel}</LabelText>
                {field.price?.priceGross && (
                    <div>
                        {formatCurrency(
                            field.price?.priceGross,
                            field.price?.currency
                        )}{" "}
                        <span className="text-gray-500">
                            (<Trans i18nKey="orderEntry.product.includedTax"
                                    tax={field.price?.vat / 100}>incl. {{tax: field.price?.vat / 100}}%</Trans>)
                        </span>
                    </div>
                )}
                {field.description && (
                    <LabelDescription size={field.descriptionSize || "small"} className="line-clamp-3 !text-gray-400">
                        {field.description}
                    </LabelDescription>
                )}

                {notZero && (
                    <div className="mt-4">
                        <FormControl
                            variant="outlined"
                            size={"small"}
                            onClick={(event) => {
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                        >
                            <InputLabel id="filter-client">
                                <Trans i18nKey="orderEntry.quantity.label">
                                    Amount
                                </Trans>
                            </InputLabel>
                            <Select
                                labelId="filter-client"
                                label={
                                    <Trans i18nKey="orderEntry.quantity.label">
                                        Amount
                                    </Trans>
                                }
                                size={'small'}
                                //value={service}
                                onChange={(e, val) => {
                                    //setFormDirty(setService(e.target.value))
                                    onChange(e.target.value);
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                                value={input.value}
                                native
                            >
                                {
                                    //Create array with 1000 items
                                    [...Array(isNil(field.maxQuantity) || isNaN(field.maxQuantity) ? 1000 : field.maxQuantity).keys()]
                                        .map((item) => {
                                            // Start from quantity = 1
                                            item += 1;
                                            return (
                                                <option
                                                    key={String(item)}
                                                    value={String(item)}
                                                >
                                                    {String(item)}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                )}

                <div className="mt-auto">
                    {field.maxQuantity === 0 || isNil(field.maxQuantity) || isNaN(field.maxQuantity) ? (
                        <>
                            {field.hideUnavailableContactLink ? (
                                <>
                                    {page.props.client.key === 'amazon' ?
                                        <PartMissingModal productTitle={field.titel}/> :
                                        <div
                                            className={classNames("text-sm mt-2 no-underline block w-full font-bold bg-white rounded-md text-secondary px-9 py-3  hover:bg-secondary hover:text-white cursor-pointer shadow-lg")}>
                                            <Trans i18nKey="orderEntry.product.notAvailable">Not available</Trans>
                                        </div>}
                                </>
                            ) : (
                                <InertiaLink
                                    href={route('contact')}
                                    className={classNames("text-sm mt-2 no-underline block w-full font-bold bg-white rounded-md text-secondary px-9 py-3  hover:bg-secondary hover:text-white cursor-pointer shadow-lg")}
                                >
                                    <Trans i18nKey="orderEntry.product.notAvailable">Not available</Trans>:{" "}
                                    <Trans i18nKey="orderEntry.product.contactUs">Contact us</Trans>
                                </InertiaLink>
                            )}
                        </>
                    ) : (
                        <div className="mt-auto">
                            <button
                                className={classNames("mt-2 no-underline block w-full font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary cursor-pointer shadow-lg", {
                                    // "appearance-none font-semibold border-b cursor-pointer bg-none bg-transparent p-0 m-0": true,
                                    // "text-red-500 border-red-500 ": input.value !== "0",
                                    // "text-red-700 border-red-700 ": input.value === "0",
                                })}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    if (notZero) {
                                        return onChange("0");
                                    }

                                    return onChange("1");
                                }}
                            >
                                {
                                    notZero ?
                                        <Trans i18nKey="common.remove">Remove</Trans>
                                        :
                                        <Trans i18nKey="common.add">Add</Trans>
                                }
                            </button>

                        </div>
                    )}
                    {!field.hideProductDetailsButton && (
                        <button
                            type="button"
                            onClick={() => setIsProductModalOpen(true)}
                            className={classNames("mt-2 no-underline block w-full font-bold bg-white rounded-md text-secondary px-9 py-3  hover:bg-secondary hover:text-white cursor-pointer shadow-lg")}
                        >
                            <Trans i18nKey="orderEntry.product.viewDetails">View details</Trans>
                        </button>
                    )}
                </div>
            </Label>

            <ProductModal
                isOpen={isProductModalOpen}
                onClose={() => setIsProductModalOpen(false)}
                title={field.titel}
                description={field.description}
                imgUrl={field.image ? field.image : null}
                price={
                    <div>
                        {formatCurrency(
                            field.price?.priceGross,
                            field.price?.currency
                        )}{" "}
                        <span className="text-gray-500 font-normal">
                            (<Trans i18nKey="orderEntry.product.includedTax"
                                    tax={field.price?.vat / 100}>incl. {{tax: field.price?.vat / 100}}%</Trans>)
                        </span>
                    </div>
                }
            />
        </div>
    );
}

export default RadioBigWithAmount;
